module.exports = __webpack_public_path__ + "img/KN.37ebc254.png";